import React from 'react';
import { Form, Input, Button, Typography } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import { useState } from 'react';
import './Login.css'; // Import the CSS file
import './common.css'; // Import the common CSS file

const { Title } = Typography;

const Login = () => {
    const navigate = useNavigate();
    const [emailErrorMessage, setEmailErrorMessage] = useState(null);
    const [passwordErrorMessage, setPasswordErrorMessage] = useState(null);
    
    const onFinish = async (values) => {
        try {
            const response = await fetch('https://54.178.141.189/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: values.email,
                    password: values.password, // Send the plain text password
                }),
            });
            const data = await response.json();
            if (data.success) {
                console.log(data);
                sessionStorage.setItem('userId', data.userId); 
                sessionStorage.setItem('name', data.userName); 
                navigate('/borrow');
            } else {
                console.error(data.message);
                if (data.message === 'User not found') {
                    setEmailErrorMessage(data.message);
                } else if (data.message === 'Need email confirmation') {
                    setEmailErrorMessage(data.message);
                } else if (data.message === 'Invalid password') {
                    setPasswordErrorMessage(data.message);
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <div className="borrow-container">
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '100vh' }}>
            <div className="content-container-app">
            <Title level={1} style={{ fontFamily: 'Normal', fontSize: '2.5rem', fontWeight: 'bold', textAlign: 'center' , marginBottom:"0rem"}}>臺大循環餐盒系統試辦計畫</Title>
            <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '0rem' }}>NTU ECOntainer Pilot Program</p>
            <img src="/eco-packaging.png" alt="Logo" style={{ width: '25%'}} />
                <Title style={{marginBottom:"0rem"}}level={2} className="sub-title">使用者登入</Title>
                <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '0rem' }}>User Login</p>
                <div className="form-container">
                    <Form
                        name="login"
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="email"
                            label="NTU Mail："
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your email!',
                                },
                            ]}
                            help={emailErrorMessage}
                            validateStatus={emailErrorMessage ? 'error' : ''}
                        >
                            <Input onChange={() => setEmailErrorMessage(null)} />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            label="Password："
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!',
                                },
                            ]}
                            help={passwordErrorMessage}
                            validateStatus={passwordErrorMessage ? 'error' : ''}
                        >
                            <Input.Password onChange={() => setPasswordErrorMessage(null)} />
                        </Form.Item>

                        <Form.Item className="form-item-center">
                            <Button type="primary" htmlType="submit">
                                Log in
                            </Button>
                        </Form.Item>
                        <Form.Item className="form-item-center">
                            <Link to="/forgot-password">忘記密碼 <br/>Forgot password?</Link>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
        </div>
    );
};

export default Login;